import React, {ReactElement} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {sx} from './sx'

import SecondaryButtonSingleVoyage
    from "@containers/singleVoyage/ui/buttonts/secondaryButtonSingleVoyage/SecondaryButtonSingleVoyage";
import {
    buildPathToTaskTemplatesSingleVoyage
} from "@containers/singleVoyage/views/links/linkToTaskTemplatesSingleVoyage/helpers/buildPathToTaskTemplatesSingleVoyage";

interface IProps {
    button?: ReactElement,
    accountId: string | number
}

const LinkToTaskTemplatesSingleVoyage = ({
                                             button,
                                             accountId
                                         }: IProps) => {

    const {t} = useTranslation()

    const path = buildPathToTaskTemplatesSingleVoyage({accountId})

    return (
        <Link to={path}>
            {button ?? <SecondaryButtonSingleVoyage
                sx={sx.root}
            >
                {t('singleVoyage.tasksTemplates')}
            </SecondaryButtonSingleVoyage>}
        </Link>
    );
};

export default LinkToTaskTemplatesSingleVoyage;
